import { render, staticRenderFns } from "./xeCodemirror.vue?vue&type=template&id=7246c1d3&scoped=true"
import script from "./xeCodemirror.vue?vue&type=script&lang=js"
export * from "./xeCodemirror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246c1d3",
  null
  
)

export default component.exports